import { DialogActions, DialogContent, DialogTitle, TextField, Button, Dialog, Stack } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export function PurchaseOrderDetailsNoteModal() {
  const { note, noteId, isNoteModalOpen, closeModal, handleNotesChange, isEditable } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const { t } = useTranslation('purchaseOrderDetails');

  const [unSavedNote, setUnSavedNote] = useState(note);

  useEffect(() => { setUnSavedNote(note); }, [note, noteId]);

  const handleClose = () => {
    setUnSavedNote(note);
    closeModal();
  };

  const handleSave = () => {
    handleNotesChange(noteId, unSavedNote);
    closeModal();
  };

  const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUnSavedNote(event.target.value);
  };

  return (
    <Dialog onClose={handleClose}
      open={isNoteModalOpen}>
      <DialogTitle>
        {isEditable ? t('noteModal.editNote') : t('noteModal.note')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        {isEditable ? <TextField value={unSavedNote}
          onChange={handleNoteChange} />
          :
          unSavedNote}
      </DialogContent>
      <DialogActions>

        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='secondary'
            fullWidth
            size="lg"
            onClick={handleClose}>
            {t('noteModal.close')}
          </Button>
          {isEditable && <Button variant='primary'
            fullWidth
            size="lg"
            onClick={handleSave}>
            {t('noteModal.saveNote')}
          </Button>}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
